module.exports = __webpack_public_path__ + "static/media/Avatar_9.f695e384.svg";